import { Divider, Grid, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";

import VCERNTypography from "../../common/elements/VCERNTypography";

import { connect } from "react-redux";
import icons from "../../common/icons";
import DashboardHeader from "../../common/DashboardHeader";
import AC from "../../redux/actions/actionCreater";
import { getRoles } from "../../common/data";
import VCERNAlert from "../../common/elements/VCERNAlert";
import HeadingWithLine from "../../common/elements/HeadingWithLine";

const useStyles = makeStyles((theme) => ({
  input: { margin: "5px 0" },
  title: { margin: "15px 0", fontWeight: "bold" },
  main: { margin: "20px 0", width: "100%" },
  inline: { margin: "15px 0 15px 15px", display: "flex", alignItems: "center" },
  icon: { marginRight: 15 },
  optionText: { fontWeight: "normal", flexGrow: 1 },
  divider: { margin: "20px 0" },
  goIcon: { cursor: "pointer" },
}));

function Settings({
  setCurrentPageTitle,
  type,
  getPreSignedLink,
  uploadFile,
  updateMember,
  setError,
  token,
}) {
  const classes = useStyles();
  const history = useHistory();
  const [successMessage, setSuccessMessage] = useState(false);

  useEffect(() => {
    setCurrentPageTitle(`${getRoles[type]} Settings`);

    // eslint-disable-next-line
  }, []);
  const handleAttachment = (evt) => {
    const file = evt.target.files[0];

    if (file?.size > 5242880)
      return setError("You cannot uploade a file greater than 5MB.");

    if (file) {
      const { name, type } = file;
      getPreSignedLink({ name, type }, (url) =>
        uploadFile({ url, file, type }, () => {
          updateMember({ image: url.split("?")[0] }, token, () => {
            setSuccessMessage("User Updated Successfully");
          });
        })
      );
    }
  };
  return (
    <Grid container>
      <DashboardHeader />
      <div className={classes.main}>
        <HeadingWithLine>Transactions</HeadingWithLine>
        <div className={classes.inline}>
          <div className={classes.icon}>{icons.dollar}</div>
          <VCERNTypography
            className={classes.optionText}
            variant="body1"
            value="Payment History"
          />
          <div
            className={classes.goIcon}
            onClick={() => history.push("/payments")}
          >
            {icons.arrowRight}
          </div>
        </div>
        <div className={classes.inline}>
          <div className={classes.icon}>{icons.zip}</div>
          <VCERNTypography
            className={classes.optionText}
            variant="body1"
            value="Payment Methods"
          />
          <div
            className={classes.goIcon}
            onClick={() => history.push("/payments")}
          >
            {icons.arrowRight}
          </div>
        </div>

        <HeadingWithLine>General</HeadingWithLine>

        <div className={classes.inline}>
          <div className={classes.icon}>{icons.eye}</div>
          <VCERNTypography
            className={classes.optionText}
            variant="body1"
            value="View Profile"
          />
          <div
            className={classes.goIcon}
            onClick={() => history.push("/profile")}
          >
            {icons.arrowRight}
          </div>
        </div>
        <div className={classes.inline}>
          <div className={classes.icon}>{icons.settings}</div>
          <VCERNTypography
            className={classes.optionText}
            variant="body1"
            value="Edit Profile"
          />
          <div
            className={classes.goIcon}
            onClick={() => history.push("/edit-profile")}
          >
            {icons.arrowRight}
          </div>
        </div>
        <div className={classes.inline}>
          <div className={classes.icon}>{icons.image}</div>
          <VCERNTypography
            className={classes.optionText}
            variant="body1"
            value="Update Profile Picture"
          />
          <label htmlFor="upload-photo">
            <div className={classes.goIcon}>{icons.arrowRight}</div>
          </label>
          <input
            id="upload-photo"
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={handleAttachment}
          />
        </div>
        <div className={classes.inline}>
          <div className={classes.icon}>{icons.uploadDocs}</div>
          <VCERNTypography
            className={classes.optionText}
            variant="body1"
            value="View/Upload Docs & Pics"
          />
          <div
            className={classes.goIcon}
            onClick={() => history.push("/documents")}
          >
            {icons.arrowRight}
          </div>
        </div>
        <div className={classes.inline}>
          <div className={classes.icon}>{icons.share}</div>
          <VCERNTypography
            className={classes.optionText}
            variant="body1"
            value="Invite Friends"
          />
          <div
            className={classes.goIcon}
            onClick={() => history.push("/invite")}
          >
            {icons.arrowRight}
          </div>
        </div>

        <HeadingWithLine>Legal Information</HeadingWithLine>

        <div className={classes.inline}>
          <div className={classes.icon}>{icons.blogs}</div>
          <VCERNTypography
            className={classes.optionText}
            variant="body1"
            value="Terms & Conditions"
          />
          <div
            className={classes.goIcon}
            onClick={() => {
              const win = window.open("/terms-and-conditions", "_blank");
              win.focus();
            }}
          >
            {icons.arrowRight}
          </div>
        </div>
        <div className={classes.inline}>
          <div className={classes.icon}>{icons.blogs}</div>
          <VCERNTypography
            className={classes.optionText}
            variant="body1"
            value="Terms & Conditions"
          />
          <div
            className={classes.goIcon}
            onClick={() => {
              const win = window.open("/terms-and-conditions", "_blank");
              win.focus();
            }}
          >
            {icons.arrowRight}
          </div>
        </div>
        <div className={classes.inline}>
          <div className={classes.icon}>{icons.blogs}</div>
          <VCERNTypography
            className={classes.optionText}
            variant="body1"
            value="Privacy Policy"
          />
          <div
            className={classes.goIcon}
            onClick={() => {
              const win = window.open("/payment-agreements", "_blank");
              win.focus();
            }}
          >
            {icons.arrowRight}
          </div>
        </div>
      </div>
      <VCERNAlert
        message={successMessage}
        onClose={() => setSuccessMessage(false)}
        success={true}
      />
    </Grid>
  );
}
export default connect((state) => state, {
  setCurrentPageTitle: AC.setCurrentPageTitle,
  getPreSignedLink: AC.getPreSignedLink,
  uploadFile: AC.uploadFile,
  updateMember: AC.updateMember,
  setError: AC.setError,
})(Settings);
